export type SheetRow = {
  ticker: string;
  nums: readonly [string, string, string, string, string, string];
};

export const ROWS: SheetRow[] = [
  { ticker: 'AAPL', nums: ['90', '$12.4', '0.8%', '$14.2', '$9.03', '-1%'] },
  { ticker: 'MSFT', nums: ['12', '$52.8', '3.1%', '$8.6', '$41.2', '+3%'] },
  { ticker: 'NVDA', nums: ['84', '$19.5', '6.0%', '$22', '$7.4', '+4%'] },
  { ticker: 'AMZN', nums: ['55', '$34.1', '1.1%', '$5.6', '$18.9', '0.4%'] },
  { ticker: 'GOOGL', nums: ['25', '$13.0', '2.6%', '$9.8', '$4.17', '+1%'] },
  { ticker: 'CVX', nums: ['41', '$24.2', '-3%', '$11', '$6.8', '-3%'] },
  { ticker: 'META', nums: ['12', '$26.8', '-1%', '$15.3', '$8.2', '-4%'] },
  { ticker: 'TSLA', nums: ['55', '$31.5', '2.1%', '$17', '$10.4', '+2%'] },
];

export const COLS = ['A', 'B', 'C', 'D', 'E', 'F', 'G'] as const;
export const WIDE_HEAD = ['Ticker', 'Qty', 'Amt', 'Rate', 'Max', 'Min', 'Net'];
export const NARROW_HEAD = ['Ticker', 'Amt', 'Net'];

export function colAlign(c: number): 'right' | undefined {
  return c > 0 ? 'right' : undefined;
}

export function rowValues(row: SheetRow, wide?: boolean): string[] {
  if (!wide) return [row.ticker, row.nums[1], row.nums[5]];
  return [row.ticker, ...row.nums];
}

export type SheetRange = {
  startCol: number;
  startRow: number;
  endCol: number;
  endRow: number;
};

export function parseSheetRange(range: string): SheetRange | undefined {
  const [from, to] = range.split(':');
  const start = parseA1(from);
  const end = parseA1(to ?? from);
  if (!start || !end) return undefined;
  return {
    startCol: Math.min(start.col, end.col),
    startRow: Math.min(start.row, end.row),
    endCol: Math.max(start.col, end.col),
    endRow: Math.max(start.row, end.row),
  };
}

function parseA1(ref: string | undefined) {
  if (!ref) return undefined;
  const match = /^([A-Za-z]+)(\d+)$/.exec(ref);
  if (!match) return undefined;
  return { col: colIndex(match[1]!), row: Number(match[2]) };
}

function colIndex(letters: string): number {
  let n = 0;
  for (const ch of letters.toUpperCase()) {
    n = n * 26 + (ch.charCodeAt(0) - 64);
  }
  return n - 1;
}
